import React from 'react';
const Thead = props => {
    return (
        <thead className="thead-light">
            {props.children}
        </thead>
    )
};
export default Thead